import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule, MatCheckboxModule, MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {MatInputModule} from '@angular/material/input';
import {MatCardModule} from '@angular/material/card';
import	{MatDialogModule} from '@angular/material';

import { AppComponent } from './app.component';
import { RootComponent, DialogOverviewExampleDialog } from './root/root.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';


@NgModule({
  declarations: [
    AppComponent,
    RootComponent,
	DialogOverviewExampleDialog
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatCardModule,
    Ng2SearchPipeModule,
	MatDialogModule
  ],
  providers: [MatDialogModule],
  bootstrap: [AppComponent],
  entryComponents: [DialogOverviewExampleDialog]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts